// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1XrDE","dragIcon":"SortableItem_dragIcon__BNgyr","disabled":"SortableItem_disabled__2OZ63"};